import React, {Component} from 'react';
import _ from 'lodash';
import Autosuggest from 'react-autosuggest';

const renderSuggestion = suggestion => (
  <div className="row">
    <div className="col-11">
      {suggestion.value}
    </div>
  </div>
);

export default class AutoCompleteTextField extends Component {
  constructor(props){
    super(props)

    this.state = {
      options: [],
      value: '',
      suggestions: []
    }

    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps !== this.props) {
      this.setState({
        value: nextProps.value,
        options: nextProps.options
      });
    }
  }

  onChange(event, { newValue }){
    this.setState({
      value: newValue
    }, () => {
      const field = this.props.field;
      this.props.onChange(field, newValue);
    });
  };

  getSuggestions(value){
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : this.state.options.filter(option =>
      option.value.toLowerCase().includes(inputValue)
    );
  };

  getSuggestionValue(suggestion){
    return suggestion.value;
  }

  onSuggestionsFetchRequested({ value }){
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  onSuggestionsClearRequested(){
    this.setState({
      suggestions: []
    });
  };

  render(){
    const { value, suggestions } = this.state;

    const inputProps = {
      value,
      onChange: this.onChange
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AutoCompleteTextField.js